export const mimeTypeFileExtensionMap = new Map<string, string[]>([
	['application/zip', ['zip']],
	['application/pdf', ['pdf']],
	['application/msword', ['doc', 'docx']],
	['application/vnd.ms-excel', ['xls', 'xlsx']],
	['application/vnd.ms-powerpoint', ['ppt', 'pptx']],
	['application/vnd.openxmlformats-officedocument.wordprocessingml.document', ['doc', 'docx']],
	['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', ['xls', 'xlsx']],
	['application/vnd.openxmlformats-officedocument.presentationml.presentation', ['ppt', 'pptx']],
	['application/postscript', ['ps', 'eps']],
	['application/rtf', ['rtf']],
	['application/photoshop', ['psd']],
	['application/illustrator', ['ai']],
	['application/indesign', ['indd', 'idml']],
	['application/x-indesign', ['indd', 'idml']],
	['text/plain', ['txt']],
	['text/csv', ['csv']],
	['image/*', ['jpeg', 'jpg', 'png', 'bmp', 'tiff', 'gif', 'svg']],
	['image/jpeg', ['jpeg', 'jpg']],
	['image/png', ['png']],
	['image/bmp', ['bmp']],
	['image/gif', ['gif']],
	['image/svg+xml', ['svg']],
]);
